import { useTranslation } from "react-i18next";
import { FiPhone } from "react-icons/fi";
import heroImage from "../assets/hero-image.jpg";

const Hero = () => {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto px-6 pt-4 pb-8 md:px-20">
      <div className="relative w-full rounded-2xl overflow-hidden">
        <img
          className="w-full h-350 lg:h-400 xl:h-570 object-cover"
          src={heroImage}
          alt="hero"
        />

        <div className="absolute inset-0 bg-black/40"></div>

        <div className="absolute inset-0 flex flex-col justify-center items-center px-6 md:px-12 text-white">
          <h1 className="text-2xl text-center md:text-4xl font-medium mb-8 md:mb-4 lg:mb-6 lg:text-5xl xl:text-6xl">
            {t("ecoTransGeorgia")}
          </h1>

          <p className="max-w-670 font-light text-center text-sm md:text-base xl:text-xl mb-6 leading-relaxed">
            {t("ecoTransGeorgiaInfo")}
          </p>

          <a
            href="tel:+995599000000"
            className="flex justify-center items-center gap-2 w-fit bg-brand hover:bg-brand-hover text-white px-6 py-3 rounded-full bg-green transition-all duration-300 hover:bg-greenDark"
          >
            <FiPhone />
            {t("call")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Hero;
